
import { defineComponent, computed, reactive, PropType } from 'vue'

export enum ButtonThemeStyle {
  PRIMARY = 'primary',
  OUTLINE_PRIMARY = 'outline_primary',
}
export enum ButtonSizeStyle {
  H50,
  H42,
  H32,
}

export default defineComponent({
  name: 'Button',
  inheritAttrs: true,
  props: {
    color: {
      type: String as PropType<ButtonThemeStyle>,
      required: true,
    },
    size: {
      type: Number as PropType<ButtonSizeStyle>,
      required: true,
    },
    block: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const state = reactive({
      classes: computed(() => ({
        Button: true,
        'Button--primary': props.color === ButtonThemeStyle.PRIMARY,
        'Button--outline-primary': props.color === ButtonThemeStyle.OUTLINE_PRIMARY,
        'Button--H50': props.size === ButtonSizeStyle.H50,
        'Button--H42': props.size === ButtonSizeStyle.H42,
        'Button--H32': props.size === ButtonSizeStyle.H32,
        'Button--block': props.block,
      })),
    })

    return state
  },
})
